import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

export type BannerVariant = 'info' | 'success' | 'warning' | 'stale' | 'critical'

// Reusable app-wide notice banner (subscription expired, AWS outage, …).
// Presentational only: callers decide when it shows and what it says (via content
// projection) and own any dismissal persistence.
@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerComponent {
  @Input() variant: BannerVariant = 'info'
  @Input() dismissible = false

  @Output() dismissed = new EventEmitter<void>()

  onDismiss() {
    this.dismissed.emit()
  }
}
